module.exports = __webpack_public_path__ + "static/media/ErrorOrdersScreen.fbe73796.png";